import MyHeader from './header.vue'

const Header = {
  install: function (Vue) {
    Vue.component('Header', MyHeader)
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js